import React, { useState, useEffect } from "react";
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Slide from '@mui/material/Slide';
import ReplayCircleFilledIcon from '@mui/icons-material/ReplayCircleFilled';
import "./Snackbar.css";

const SnackbarHandler = ({ children, handleSnackbar }) => {

  const [snackPack, setSnackPack] = useState([]);
  const [open, setOpen] = useState(false);
  const [messageInfo, setMessageInfo] = useState(undefined);
  const [newMessage, setNewMessage] = handleSnackbar();

  useEffect(() => {
    if (newMessage.message !== "" && newMessage.severity !== "") {
      const { message, severity, reloadButton } = newMessage;
      setSnackPack((prev) => [...prev, { message, severity, reloadButton, key: new Date().getTime() }]);
    }
  }, [newMessage]);

  useEffect(() => {
    if (snackPack.length && !messageInfo) {
      setMessageInfo({ ...snackPack[0] });
      setSnackPack((prev) => prev.slice(1));
      setOpen(true);
    } else if (snackPack.length && messageInfo && open) {
      setOpen(false);
    }
  }, [snackPack, messageInfo, open]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleExited = () => {
    setMessageInfo(undefined);
    setNewMessage({ message: "", severity: "" });
  };

  const handleReload = () => {
    window.location.reload();
  }

  return (
    <>
      <Snackbar
        key={messageInfo && messageInfo.key}
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        TransitionProps={{ onExited: handleExited }}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        TransitionComponent={Slide}
        transitionDuration={300}
      >
        <Alert
          severity={messageInfo && messageInfo.severity}
          variant="filled"
          onClose={handleClose}
          elevation={5}
          sx={{ mt: 2 }}
          action={
            messageInfo && messageInfo.reloadButton &&
            <div onClick={handleReload} className="reload__icon">
              <ReplayCircleFilledIcon fontSize="medium" />
            </div>
          }
        >
          {messageInfo && messageInfo.message}
        </Alert>
      </Snackbar>
      {children}
    </>
  );
}

export const useSnackbar = () => {
  const [newMessage, setNewMessage] = useState({
    message: "",
    severity: "",
    reloadButton: false
  });

  const handleSnackbar = () => {
    return [newMessage, setNewMessage];
  }

  const error = (message) => {
    setNewMessage({ message, severity: "error", reloadButton: false });
  }

  const reloadError = (message) => {
    setNewMessage({ message, severity: "error", reloadButton: true });
  }

  const warning = (message) => {
    setNewMessage({ message, severity: "warning", reloadButton: false });
  }
  const info = (message) => {
    setNewMessage({ message, severity: "info", reloadButton: false });
  }
  const success = (message) => {
    setNewMessage({ message, severity: "success", reloadButton: false });
  }

  const createSnackbar = {
    error,
    reloadError,
    warning,
    info,
    success
  }

  return {
    handleSnackbar,
    createSnackbar
  }

};

export default SnackbarHandler;
